<template>
  <div class="container">
    <div class="title-row">
      <h2>Billing History</h2>
      <div class="right-content form-area" v-if="years.length > 1">
        <p class="h4">Invoice Range:</p>
        <div class="select-wrap">
          <select v-model="selectedYear" @change="resetDownloadButton">
            <option value="All" selected>All</option>
            <option v-for="year in years" :value="year" v-bind:key="year">{{year}}</option>
          </select>
          <div class="caret"></div>
        </div>
      </div>
      <button @click="downloadBillingInfo" class="btn" :disabled="isDownloading || finished" aria-label="Download billing history">
        <transition name="fade">
          <div v-if="finished" class="button-state checkmark"></div>
          <div v-else-if="isDownloading" class="button-state spinner"></div>
        </transition>
        <span class="text" :class="{ 'hidden': finished || isDownloading }">Download</span>
      </button>
    </div>
    <div v-if="errorMessage" class="alert alert-danger text-center">{{ errorMessage }}</div>
    <div v-if="historyRetrieved">
      <div v-if="visibleBillingHistory.length > 0">
        <div class="billing-table">
          <div class="table-row">
            <div v-for="title in ['Date', 'Description', 'Price', 'Receipt']" v-bind:key="title" class="item">
              <h6>{{ title }}</h6>
            </div>
          </div>
          <div v-for="bill in visibleBillingHistory" v-bind:key="bill.url" class="table-row">
            <div class="item">
              <p>{{ getDate(bill.date) }}</p>
            </div>
            <div class="item">
              <p>{{ bill.description }}</p>
            </div>
            <div class="item">
              <p>{{ bill.total | money }}</p>
            </div>
            <div class="item">
              <a :href="bill.url">Print</a>
            </div>
          </div>
        </div>
        <p>(We show up to two years of billing history, all funds are in USD.)</p>
      </div>
      <div v-else-if="historyRetrieved && !errorMessage">
        <p class="no-history">You don't have any billing history yet.</p>
      </div>
    </div>
    <div v-else>
      <spinner></spinner>
    </div>
    <iframe style="display:none;" :src="frameSrc"></iframe>
  </div>
</template>

<script>
import services from '@/services/services.js'
import spinner from '@/components/spinner/spinner'

export default {
  name: 'billing',
  data () {
    return {
      isDownloading: false,
      finished: false,
      frameSrc: '',
      errorMessage: '',
      historyRetrieved: false,
      selectedYear: 'All'
    }
  },
  components: {
    spinner: spinner
  },
  created: function () {
    this.getBillingData()
  },
  computed: {
    billingHistory: function () {
      return this.$store.getters.billingData || []
    },
    visibleBillingHistory () {
      return this.billingHistory.filter((value) => {
        if (this.selectedYear === 'All') return true
        return value.date.substring(0, 4) === this.selectedYear
      })
    },
    years: function () {
      let year = ''
      let years = []

      for (let x = 0; x < this.billingHistory.length; x++) {
        year = this.billingHistory[x].date.substring(0, 4)
        if (years.indexOf(year) === -1) {
          years.push(year)
        }
      }
      return years.sort().reverse()
    },
    downloadBillingURL: function () {
      return this.ENV.coreBaseUrl + '/team/downloadInvoice' + (this.selectedYear !== 'All' ? '?year=' + this.selectedYear : '')
    }
  },
  filters: {
    money: function (val) {
      let neg = ''
      if (val < 0) {
        neg = '-'
        val = val * -1
      }
      return neg + '$' + String(val.toFixed(2))
    }
  },
  methods: {
    getDate: function (date) {
      return services.formatDate(date, true)
    },
    getBillingData: function () {
      this.$store.dispatch('getBillingData').then(() => {
        this.historyRetrieved = true
      }).catch(() => {
        this.historyRetrieved = true
        this.errorMessage = 'There was an issue retrieving your billing data. Please refresh the page and try again.'
      })
    },
    downloadBillingInfo: function () {
      this.isDownloading = true
      this.frameSrc = this.downloadBillingURL
      setTimeout(() => {
        this.isDownloading = false
        this.finished = true
      }, 1000)
    },
    resetDownloadButton: function () {
      this.isDownloading = false
      this.finished = false
    }
  }
}
</script>

<style scoped lang="stylus" src="./billing.styl" >



// WEBPACK FOOTER //
// src/views/billing/billing.vue